import { render } from "./app-system-secondary-layout2.vue?vue&type=template&id=144d94bd&scoped=true&ts=true"
import script from "./app-system-secondary-layout2.vue?vue&type=script&lang=ts"
export * from "./app-system-secondary-layout2.vue?vue&type=script&lang=ts"

import "./app-system-secondary-layout2.vue?vue&type=style&index=0&id=144d94bd&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144d94bd"]])

export default __exports__